import React from 'react';
//COMPONENTES
import {useStyles} from './style';
import { functions } from "constants/index";
import {Menu} from '@material-ui/icons/';
import { AppBar, Button, Container, Grid, IconButton, Toolbar, Typography } from '@material-ui/core';

export default function FiltrosParaGenerarConstanciaDeActa (props) {
    const classes = useStyles();

   const DescargarPDF = () => {functions.downloadPDFFromStringBase64(props.base64, 'Informe de cierre.pdf');}    
    return (
        <div>
            <br/>
            <Container maxWidth="lg">        
                <Grid container className={classes.colorComponente} style={{width: '100%', position: 'relative', overflow: 'auto', border: '1px solid  #cccccc', borderRadius: '20px', marginBottom:10,}}>
                        <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">
                            <AppBar position="static" className={classes.appBar}>
                                <Toolbar variant="dense">
                                    <IconButton edge="start" className={classes.menuButton} aria-label="menu">
                                        <Menu className={classes.icon}/>
                                    </IconButton>
                                    <Typography className={classes.title} variant="subtitle1" gutterBottom>Ver Informe</Typography>
                                    <Button className={classes.button} onClick={DescargarPDF}>Descargar Informe</Button>
                                </Toolbar>
                            </AppBar>
                        </Grid>
                        <Grid className={classes.gridIframe} item xs={12} container direction="row" justifyContent="center" alignItems="center">
                            <iframe title="informe1_powerBio" width="100%" height="100%" src={`data:application/pdf;base64,${props.base64}`} frameborder="0" allowFullScreen="false"></iframe>
                        </Grid>
                </Grid>
            </Container>
        </div>
    );   
}